import { useEffect, useRef, useState } from 'react';
import { useUnit } from 'effector-react';
import { $initialAccountsStore, $initialCardsStore, $initialCurrenciesAvailableStore, $profileFeatureStore, $profileStore } from '@lib/store';
import { AuthApi } from '@shared/api/rest';
import { AuthUtils, LocalAuthData } from '@shared/utils';
import { Public, Private } from '.';
import { Spinner } from '@shared/widgets';

export const Root = () => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const [isShowSpinner, setIsShowSpinner] = useState<boolean>(false);
  const [isAuth, setIsAuth] = useState<boolean>(AuthUtils.isAuth());
  const hasInitialized = useRef<boolean>(false);

  const onCallbackAuthEvent = (isAuthTmp: boolean) => {
    setIsAuth(isAuthTmp);
    if (!isAuthTmp || hasInitialized.current) return;
    hasInitialized.current = true;
    $profileFeatureStore.events.get();
    $profileStore.events.get();
    $initialAccountsStore.events.getAccounts();
    $initialCardsStore.events.getCards();
    $initialCurrenciesAvailableStore.events.getAvailableCurrencies();
  };

  useEffect(() => {
    onCallbackAuthEvent(isAuth);

    AuthUtils.eventIsAuth.on(AuthUtils.isAuthEventName, onCallbackAuthEvent);

    AuthUtils.init();

    if (!AuthUtils.isAuth()) {
      const userId = AuthUtils.getTempTokenForLogIn();
      if (userId) {
        setIsShowSpinner(true);
        AuthApi.authenticate({ tempToken: userId })
          .then((x) => {
            if (!x) return;
            AuthUtils.updateAuthData(x as LocalAuthData);
          })
          .catch(() => {
            AuthUtils.logOut();
          })
          .finally(() => {
            setIsShowSpinner(false);
          });
      } else {
        AuthUtils.redirectToLoginPage();
      }
    } else {
      AuthUtils.eventIsAuth.emit(AuthUtils.isAuthEventName, true);
    }

    return () => {
      AuthUtils.eventIsAuth.off(AuthUtils.isAuthEventName, onCallbackAuthEvent);
      hasInitialized.current = false;
    };
  }, []);

  if ((profileFeatureStore.data === null && isAuth) || isShowSpinner) return <Spinner position />;
  if (isAuth) return <Private />;
  return <Public />;
};
